import './bootstrap';
import "./cms/cms";
import "./cms/lazysizes";

import GLightbox from 'glightbox';
var lightbox = GLightbox();
